import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
  CardImg,
} from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import moment from "moment";
import _, { isObject } from "lodash";
import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../common/constants";
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const EditGrabFoodBanner = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [propsData, setPropsData] = useState(props?.location?.state);
  const [buttonText1, setbuttonText1]=useState()
  const [buttonText2, setbuttonText2]=useState()
  const [position, setPosition] = useState(1);
  const [title1, setTitle1] = useState();
  const [title2, setTitle2] = useState();
  const [description1, setDescription1] = useState();
  const [description2, setDescription2] = useState();
  //Images Url
  const [imageUrl, setImageUrl] = useState();
  const [iconUrl1, setIconUrl1] = useState();
  const [iconUrl2, setIconUrl2] = useState();
  //imageFiles
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFiles1, setSelectedFiles1] = useState([]);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const [navigation, setNavigation] = useState();
  const [navigation2, setNavigation2] = useState();

  const [version, setVersion] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [publishDate, setPublishDate] = useState("");
  const [unPublishDate, setUnPublishDate] = useState("");
  const [neverEnding, setNeverEnding] = useState(false);
  const [loader, setLoader] = useState(false);

  // state for global Nav 1
  const [selectedFRXSection, setselectedFRXSection] = useState(
    frxAppOptions[frxAppOptions.length - 1]
  );

  const [externalUrl, setExternalUrl] = useState();
  const [externalUrlErrorMessage,setExternalUrlErrorMessage]=useState('')

  const [externaLinkName,setExternalLinkName]=useState("")
  const [customCheck, setcustomCheck] = useState(false);
  const [customNavigation, setCustomNavigation] = useState(
    JSON.stringify({ section: "", custom: true })
  );
  // state for global Nav 2
  const [selectedFRXSection2, setselectedFRXSection2] = useState(
    frxAppOptions[frxAppOptions.length - 1]
  );

  const [externalUrl2, setExternalUrl2] = useState();
  const [externalUrlErrorMessage2,setExternalUrlErrorMessage2]=useState('')

  const [externaLinkName2,setExternalLinkName2]=useState()
  const [customCheck2, setcustomCheck2] = useState(false);
  const [customNavigation2, setCustomNavigation2] = useState(
    JSON.stringify({ section: "", custom: true })
  );

    // Add state for ArticleDetail navigation
  const [selectedMall1, setSelectedMall1] = useState(null);
  const [selectedHappeningType1, setSelectedHappeningType1] = useState(null);
  const [selectedMall2, setSelectedMall2] = useState(null);
  const [selectedHappeningType2, setSelectedHappeningType2] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      var imageUrl = props.location.state?.item?.userfile;

      var title_1 = props.location.state?.item?.title_1;
      var description_1 = props.location.state?.item?.description_1;
      var icon_url_1 = props.location.state?.item?.icon_1;

      var title_2 = props.location.state?.item?.title_2;
      var description_2 = props.location.state?.item?.description_2;
      var icon_url_2 = props.location.state?.item?.icon_2;

      var button_1_text = props.location.state?.item?.button_1_text;
      var button_2_text = props.location.state?.item?.button_2_text;

      var version =props.location.state?.item?.item_version
      var status = props.location.state?.item?.item_status;
      var publish_date = props.location.state?.item?.publish_date;
      var unpublish_date = props.location.state?.item?.unpublish_date;
      if (unpublish_date == "null" || !unpublish_date) {
        setNeverEnding(true);
        setUnPublishDate("");
      } else {
        setUnPublishDate(moment(unpublish_date).format("YYYY-MM-DDTHH:mm"));
      }

            // Handle ArticleDetail navigation during mount
      if (navigation?.section === "ArticleDetail") {
        const [mallValue, happeningTypeValue, articleId] = navigation?.params?.data?.split('|') || [];
        setSelectedMall1(mallOptions.find(opt => opt.label === mallValue) || null);
        setSelectedHappeningType1(happeningTypeOptions.find(opt => opt.value === happeningTypeValue) || null);
      }

      if (navigation2?.section === "ArticleDetail") {
        const [mallValue, happeningTypeValue, articleId] = navigation2?.params?.data?.split('|') || [];
        setSelectedMall2(mallOptions.find(opt => opt.label === mallValue) || null);
        setSelectedHappeningType2(happeningTypeOptions.find(opt => opt.value === happeningTypeValue) || null);
      }
      // external Url set for each section
      const data = props?.location?.state?.item;
      let sec1 = data ? JSON.parse(data?.navigate_to_1) : "";
      let sec2 = data ? JSON.parse(data?.navigate_to_2) : "";
      if (sec1?.url) {
        setExternalUrl(sec1?.url);
        setExternalLinkName(sec1?.external_link_name)
      }
      if (sec2?.url) {
        setExternalUrl2(sec2?.url);
        setExternalLinkName2(sec2?.external_link_name)
      }

      handleEditChanges(data);
      setImageUrl(imageUrl);
      // Section_1
      setTitle1(title_1);
      setDescription1(description_1);
      setIconUrl1(icon_url_1);
      // Section_2
      setTitle2(title_2);
      setDescription2(description_2);
      setIconUrl2(icon_url_2);
      setbuttonText1(button_1_text)
      setbuttonText2(button_2_text)

      setVersion(version);
      setStatus(status);
      setPublishDate(moment(publish_date).format("YYYY-MM-DDTHH:mm"));
    }
  }, []);


  const handleEditChanges = (data) => {
    let navigation1 = {};
    if (data?.navigate_to_1?.includes("{")) {
      navigation1 = JSON.parse(data?.navigate_to_1);
      setNavigation(navigation1)
    }
    if (navigation1?.custom) {
      setcustomCheck(true);
      setCustomNavigation(props?.location?.state?.item?.navigate_to_1);
    } else {
      setCustomNavigation(JSON.stringify({ section: "", custom: true }));

      if (data?.navigate_to_1?.includes("{")) {
        if (navigation1?.params?.show_add_selection_modal) {
          setselectedFRXSection({
            label: "Add Gift Card",
            value: "add_gift_card",
          });
        } else if (navigation1?.params?.show_buy_selection_modal) {
          setselectedFRXSection({
            label: "Buy Gift Card",
            value: "buy_gift_card",
          });
        } else {
          frxAppOptions?.map((item) => {
            if (item?.value == navigation1?.section) {
              setselectedFRXSection(item);
              return;
            }
          });
        }
      } else {
        frxAppOptions?.map((item) => {
          if (item.value == data?.navigate_to_1) {
            setselectedFRXSection(item);
          } else {
            if (data?.navigate_to_1?.includes("")) {
              setselectedFRXSection({ label: "No Navigation", value: "" });
              return;
            }
          }
        });
      }
    }

    // For GlobalNavDropdown 2
    let navigation2 = {};
    if (data?.navigate_to_2?.includes("{")) {
      navigation2 = JSON.parse(data?.navigate_to_2);
      setNavigation2(navigation2)
    }
    if (navigation2?.custom) {
      setcustomCheck2(true);
      setCustomNavigation2(props?.location?.state?.item?.navigate_to_2);
    } else {
      setCustomNavigation2(JSON.stringify({ section: "", custom: true }));

      if (data?.navigate_to_2?.includes("{")) {
        if (navigation2?.params?.show_add_selection_modal) {
          setselectedFRXSection2({
            label: "Add Gift Card",
            value: "add_gift_card",
          });
        } else if (navigation2?.params?.show_buy_selection_modal) {
          setselectedFRXSection2({
            label: "Buy Gift Card",
            value: "buy_gift_card",
          });
        } else {
          frxAppOptions?.map((item) => {
            if (item?.value == navigation2?.section) {
              setselectedFRXSection2(item);
              return;
            }
          });
        }
      } else {
        frxAppOptions?.map((item) => {
          if (item.value == data?.navigate_to_2) {
            setselectedFRXSection2(item);
          } else {
            if (data?.navigate_to_2?.includes("")) {
              setselectedFRXSection2({ label: "No Navigation", value: "" });
              return;
            }
          }
        });
      }
    }
  };

  const handleSubmit = () => {
    const link = document.getElementById("campaign_link_input")?.value
      ? document.getElementById("campaign_link_input")?.value
      : "";
    const link2 = document.getElementById("campaign_link_input_2")?.value
      ? document.getElementById("campaign_link_input")?.value
      : "";
    const article_id = document.getElementById("article_id_1")?.value;
    const article_id2 = document.getElementById("article_id_2")?.value;
    const titleFRX = document.getElementById("title_input_frx_1")?.value;
    const titleFRX2 = document.getElementById("title_input_frx_2")?.value;

    if (!position) {
      setErrorMessage("Please enter position");
      setErrorAlert(true);
    } else if (!imageUrl) {
      if (selectedFiles.length < 1) {
        setErrorMessage("Please select banner image");
        setErrorAlert(true);
        return;
      }
    } 
    
    if (!title1) {
      setErrorMessage("Please Enter Title (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!description1) {
      setErrorMessage("Please enter description (Section 1)");
      setErrorAlert(true);
      return;
    } else if(!buttonText1){
      setErrorMessage("Please Enter Button Text (Section 1)");
      setErrorAlert(true);
      return;
    } else if (customCheck) {
      if (!customNavigation) {
        setErrorMessage("Please Enter Navigation (Section 1)");
        setErrorAlert(true);
        return;
      }
    } else if (!iconUrl1) {
      if (selectedFiles1.length < 1) {
        setErrorMessage("Please select image (Section 1)");
        setErrorAlert(true);
        return;
      }
    } 
    
    if(selectedFRXSection.value == "NA"){
      if(!externalUrl){
        setErrorMessage("Please Enter URL (Section 1)")
        setErrorAlert(true)
        return
      }else if(externalUrlErrorMessage){
        setErrorMessage("Please enter valid URL (Section 1)")
        setErrorAlert(true)
        return
      }else if(externaLinkName.trim()===""){
        setErrorMessage("Please Enter Exit Message Description (Section 1)")
        setErrorAlert(true)
        return
      }
    }
    
    if (!title2) {
      setErrorMessage("Please Enter Title (Section 2)");
      setErrorAlert(true);
      return;
    } else if (!description2) {
      setErrorMessage("Please enter description (Section 2)");
      setErrorAlert(true);
      return;
    } else if(!buttonText2){
      setErrorMessage("Please Enter Button Text (Section 2)");
      setErrorAlert(true);
      return;
    } else if (customCheck2) {
      if (!customNavigation2) {
        setErrorMessage("Please Enter Navigation (Section 2)");
        setErrorAlert(true);
        return;
      }
    } else if (!iconUrl2) {
      if (selectedFiles2.length < 1) {
        setErrorMessage("Please select image (Section 2)");
        setErrorAlert(true);
        return;
      }
    } 
    
    if(selectedFRXSection2.value == "NA"){
      if(!externalUrl2){
        setErrorMessage("Please Enter URL (Section 2)")
        setErrorAlert(true)
        return
      }else if(externalUrlErrorMessage2){
        setErrorMessage("Please enter valid URL (Section 2)")
        setErrorAlert(true)
        return
      }else if(!externaLinkName2){
        setErrorMessage("Please Enter Exit Message Description (Section 2)")
        setErrorAlert(true)
        return
      }
    }
    
    if (publishDate == "Invalid date" || !publishDate) {
      setErrorMessage("Please select publish date");
      setErrorAlert(true);
      return;
    } else if (!neverEnding) {
      if (unPublishDate == "Invalid date" || !unPublishDate) {
        setErrorMessage("Please select unpublish date");
        setErrorAlert(true);
        return;
      } else if(unPublishDate < publishDate){
        setErrorMessage("Unpublish date should be after the publish date")
        setErrorAlert(true)
        return
             }
    }
      if(!version){
        setErrorMessage("Please enter item version")
        setErrorAlert(true)
        return
      }
    let _deeplinkObj = {
      section: "",
      params: {
        
      },
      website_params: {},
    };
    _deeplinkObj.section = "GrabFoodBanner";
    _deeplinkObj.params.CampaignMedium = "GrabFoodBanner";
    _deeplinkObj.params.link = "Grab Food Banner";

    //Navigation_1_Object_creation
    let _deeplinkObjFRX1 = {
      section: "",
      params: {
        
      },
    };
    if (selectedFRXSection) {
      _deeplinkObjFRX1.section = selectedFRXSection.value;
      _deeplinkObjFRX1.params.CampaignMedium = "GrabFood Banner";
      _deeplinkObjFRX1.params.Link = link;

      if (selectedFRXSection.value == "ewallet") {
        _deeplinkObjFRX1.params = selectedFRXSection.params;
      } else if (selectedFRXSection.value == "NA") {
        _deeplinkObjFRX1 = {};
        _deeplinkObjFRX1.section = "NA";
        _deeplinkObjFRX1.url = externalUrl;
        _deeplinkObjFRX1.external_link_name=externaLinkName;
      } else if (selectedFRXSection.value == "UobUni") {
        _deeplinkObjFRX1.section = "UobUni";
      } else if (selectedFRXSection.value == "ShowQR") {
        _deeplinkObjFRX1.section = "ShowQR";
      } else if (selectedFRXSection.value == "digital_gift_card") {
        _deeplinkObjFRX1.section = "digital_gift_card";
        _deeplinkObjFRX1.params._params = "digital_gift_card_listing";
      } else if (selectedFRXSection.value == "add_gift_card") {
        _deeplinkObjFRX1.section = "digital_gift_card";
        _deeplinkObjFRX1.params.show_add_selection_modal = true;
      } else if (selectedFRXSection.value == "buy_gift_card") {
        _deeplinkObjFRX1.section = "digital_gift_card";
        _deeplinkObjFRX1.params.show_buy_selection_modal = true;
      } else if (selectedFRXSection.value == "ArticleDetail") {
        _deeplinkObjFRX1.params.data = `${selectedMall1?.label}|${selectedHappeningType1?.value}|${article_id}`;
        _deeplinkObjFRX1.params.title = titleFRX;
        _deeplinkObjFRX1.params.article = {
          category: titleFRX,
          id: `${selectedMall1?.label}|${selectedHappeningType1?.value}|${article_id}`,
        };
      } else if (selectedFRXSection.value == "RewardsTab") {
        _deeplinkObjFRX1.params.Link = link;
      } else if (selectedFRXSection.value == "No Navigation") {
        _deeplinkObjFRX1 = " ";
      } else if (selectedFRXSection.value == "BuyForMySelf") {
        _deeplinkObjFRX1.params.buy_for = "me";
      }
    }

    //Navigation_2_Object_creation
    let _deeplinkObjFRX2 = {
      section: "",
      params: {
        
      },
    };
    if (selectedFRXSection2) {
      _deeplinkObjFRX2.section = selectedFRXSection2.value;
      _deeplinkObjFRX2.params.CampaignMedium = "GrabFood Banner";
      _deeplinkObjFRX2.params.Link = link;

      if (selectedFRXSection2.value == "ewallet") {
        _deeplinkObjFRX2.params = selectedFRXSection2.params;
      } else if (selectedFRXSection2.value == "NA") {
        _deeplinkObjFRX2 = {};
        _deeplinkObjFRX2.section = "NA";
        _deeplinkObjFRX2.url = externalUrl2;
        _deeplinkObjFRX2.external_link_name=externaLinkName2;
      } else if (selectedFRXSection2.value == "UobUni") {
        _deeplinkObjFRX2.section = "UobUni";
      } else if (selectedFRXSection2.value == "ShowQR") {
        _deeplinkObjFRX2.section = "ShowQR";
      } else if (selectedFRXSection2.value == "digital_gift_card") {
        _deeplinkObjFRX2.section = "digital_gift_card";
        _deeplinkObjFRX2.params._params = "digital_gift_card_listing";
      } else if (selectedFRXSection2.value == "add_gift_card") {
        _deeplinkObjFRX2.section = "digital_gift_card";
        _deeplinkObjFRX2.params.show_add_selection_modal = true;
      } else if (selectedFRXSection2.value == "buy_gift_card") {
        _deeplinkObjFRX2.section = "digital_gift_card";
        _deeplinkObjFRX2.params.show_buy_selection_modal = true;
      } else if (selectedFRXSection2.value == "ArticleDetail") {
        _deeplinkObjFRX2.params.data = `${selectedMall2?.label}|${selectedHappeningType2?.value}|${article_id2}`;
        _deeplinkObjFRX2.params.title = titleFRX2;
        _deeplinkObjFRX2.params.article = {
          category: titleFRX,
          id: `${selectedMall2?.label}|${selectedHappeningType2?.value}|${article_id2}`,
        };
      } else if (selectedFRXSection2.value == "RewardsTab") {
        _deeplinkObjFRX2.params.Link = link2;
      } else if (selectedFRXSection2.value == "No Navigation") {
        _deeplinkObjFRX2 = " ";
      } else if (selectedFRXSection2.value == "BuyForMySelf") {
        _deeplinkObjFRX2.params.buy_for = "me";
      }
    }


    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("_method", "PUT");
    formdata.append("id", propsData?.item?.id);
    if (!imageUrl) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    formdata.append("navigate_to", JSON.stringify(_deeplinkObj));
    formdata.append("item_status", status);
    formdata.append("item_type", "MarketPlaceBanner");
    formdata.append("page", "grab_food_banner");
    formdata.append("item_version", version);
    formdata.append("sort_order", 1);
    formdata.append("publish_date", publishDate);
    formdata.append("unpublish_date", neverEnding ? null : unPublishDate);
    if (!iconUrl1) {
      formdata.append("icon_1", selectedFiles1[0], selectedFiles1[0].path);
    }
    formdata.append("title_1", title1);
    formdata.append("description_1", description1);
    formdata.append(
      "navigate_to_1",
      customCheck ? customNavigation : JSON.stringify(_deeplinkObjFRX1)
    );
    if (!iconUrl2) {
      formdata.append("icon_2", selectedFiles2[0], selectedFiles2[0].path);
    }
    formdata.append("title_2", title2);
    formdata.append("description_2", description2);
    formdata.append(
      "navigate_to_2",
      customCheck2 ? customNavigation2 : JSON.stringify(_deeplinkObjFRX2)
    );
    formdata.append("promotional_title",null)
    formdata.append("promotional_description",null)
    formdata.append("button_1_text",buttonText1)
    formdata.append("button_2_text",buttonText2)

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/marketplacebanners/update`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setLoader(false)
        if (result) {
          if (result?.message.includes("update")) {
            setSuccesAlert(true);
          }
        } else {
          setErrorMessage("Unable to Add Single Banner");
          setErrorAlert(true);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/market-place/grab-food");
        }}
        onConfirm={() => {
          props?.history.push("/market-place/grab-food");
          setSuccesAlert(false);
          setLoader(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Grab Updated Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const validateFileSize = (file, selectedValue) => {
    console.log("here is the validate file----->", file);
    var reader = new FileReader();
    console.log("here is the seleted value----->", selectedValue);
    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (width !== 140 || height !== 140) {
          setErrorMessage("Height and Width must be 140X140px");
          setErrorAlert(true);
        } else {
          handleAcceptedFiles(file, selectedValue);
        }
      };
    };
  };
  function handleAcceptedFiles(files, selectedValue) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (path == "PNG" || path == "png") {
      if (selectedValue == 1) {
        setSelectedFiles1(files);
      }
      if (selectedValue == 2) {
        setSelectedFiles2(files);
      }
      // if (selectedValue == 3) {
      //   setSelectedFiles3(files);
      // }
    } else {
      setErrorMessage("Please select a .png file");
      setErrorAlert(true);
    }
  }
  function handleBannerAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (path == "jpg" || path == "JPG") {
      setSelectedFiles(files);
      setImageUrl("")
    } else {
      setErrorMessage("Please select a .jpg file");
      setErrorAlert(true);
    }
  }

  const validateBannerFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (width !== 585 || height !== 333) {
          setErrorMessage("Height and Width must be 585X333px");
          setErrorAlert(true);
          return false;
        }
        handleBannerAcceptedFiles(file);
        return true;
      };
    };
  };
  const handleExternalUrl = (value) =>{
    setExternalUrl(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage("");
      }
    }else{
      setExternalUrlErrorMessage("");
    }
  }

  const handleExternalUrl2 = (value) =>{
    setExternalUrl2(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage2("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage2("");
      }
    }else{
      setExternalUrlErrorMessage2("");
    }
  }

  const GlobalNavDropDown = () => {
    return (
      <Form>
        <Row>
          <Col lg={4} md={10} sm={10}>
            <div className="mb-3">
              <Label>Navigate To</Label>
              {customCheck ? (
                <textarea
                  rows={4}
                  col={20}
                  type="text"
                  className="form-control"
                  id="item_group_input"
                  onChange={(e) => {
                    setCustomNavigation(e.target.value);
                  }}
                  defaultValue={customNavigation}
                />
              ) : (
                <Select
                  isSearchable={true}
                  value={selectedFRXSection}
                  onChange={(e) => {
                    setselectedFRXSection(e);
                  }}
                  placeholder={
                    selectedFRXSection?.label
                      ? selectedFRXSection?.label
                      : "Choose section..."
                  }
                  defaultValue={frxAppOptions[0]}
                  options={frxAppOptions}
                  maxMenuHeight={120}
                  menuPlacement="auto"
                  required
                />
              )}
            </div>
          </Col>
          <Col md={1}></Col>
          <Col md={2} style={{ paddingTop: "38px" }}>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input checkbox"
                id="checkbox_custom_nav"
                value={customCheck}
                defaultChecked={customCheck}
                onClick={() => {
                  setcustomCheck(!customCheck);
                }}
              />

              <label className="form-check-label" htmlFor="checkbox_pocuno">
                Custom Navigation
              </label>
            </div>
          </Col>
        </Row>
        <Row>
          {(selectedFRXSection?.label == "External Link" && !customCheck) && (
            <Col lg={4} md={6} sm={6}>
              <div className="mb-3">
                <Label>URL</Label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={externalUrl}
                  id="campaign_link_input"
                  onChange={(e) => {
                    setExternalUrl(e.target.value)
                    // handleExternalUrl(e.target.value)
                  }}
                />
              {externalUrlErrorMessage && (
                <p style={{ color: "red", fontSize: 12 }}>
                  {externalUrlErrorMessage}
                </p>
              )}
              </div>
            </Col>
          )}
        </Row>
        <Row>
          { (selectedFRXSection?.label == "External Link" && !customCheck) &&
            <Col lg={4} md={6} sm={6}>
              <div className="mb-3">
                <Label>Exit Message Description*</Label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={externaLinkName}
                  id="campaign_link_input"
                  onChange={(e) => {
                  setExternalLinkName(e.target.value)
                }}
                />
              </div>
            </Col>}
          </Row>
{(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
          <>
            <Row>
              <Col lg={4} md={6} sm={6}>
                <div className="mb-3">
                  <Label>Mall</Label>
                  <Select
                    isSearchable={true}
                    onChange={(e) => {
                      setSelectedMall1(e);
                      setSelectedHappeningType1(null);
                    }}
                    options={mallOptions}
                    placeholder="Select Mall..."
                    value={selectedMall1}
                  />
                </div>
              </Col>
            </Row>
            
            {selectedMall1 && (
              <Row>
                <Col lg={4} md={6} sm={6}>
                  <div className="mb-3">
                    <Label>Type</Label>
                    <Select
                      isSearchable={true}
                      onChange={(e) => {
                        setSelectedHappeningType1(e);
                      }}
                      options={happeningTypeOptions}
                      placeholder="Select Happening Type..."
                      value={selectedHappeningType1}
                    />
                  </div>
                </Col>
              </Row>
            )}
            
            {selectedHappeningType1 && (
              <>
                <Row>
                  <Col lg={4} md={6} sm={6}>
                    <div className="mb-3">
                      <Label>Blog ID</Label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={
                          navigation?.params?.data?.split('|')[2] || ''
                        }
                        id="article_id_1"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={6} sm={6}>
                    <div className="mb-3">
                      <Label>Header Title</Label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={
                          navigation?.params?.title || ''
                        }
                        id="title_input_frx_1"
                      />
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Form>
    );
  };

  const GlobalNavDropDown2 = () => {
    return (
      <Form>
        <Row>
          <Col lg={4} md={10} sm={10}>
            <div className="mb-3">
              <Label>Navigate To</Label>
              {customCheck2 ? (
                <textarea
                  rows={4}
                  col={20}
                  type="text"
                  className="form-control"
                  id="item_group_input"
                  onChange={(e) => {
                    setCustomNavigation2(e.target.value);
                  }}
                  defaultValue={customNavigation2}
                />
              ) : (
                <Select
                  isSearchable={true}
                  value={selectedFRXSection2}
                  onChange={(e) => {
                    setselectedFRXSection2(e);
                  }}
                  placeholder={
                    selectedFRXSection2.label
                      ? selectedFRXSection2.label
                      : "Choose section..."
                  }
                  defaultValue={frxAppOptions[0]}
                  options={frxAppOptions}
                  maxMenuHeight={120}
                  menuPlacement="auto"
                  required
                />
              )}
            </div>
          </Col>
          <Col md={1}></Col>
          <Col md={2} style={{ paddingTop: "38px" }}>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input checkbox"
                id="checkbox_custom_nav"
                value={customCheck2}
                defaultChecked={customCheck2}
                onClick={() => {
                  setcustomCheck2(!customCheck2);
                }}
              />

              <label className="form-check-label" htmlFor="checkbox_pocuno">
                Custom Navigation
              </label>
            </div>
          </Col>
        </Row>
        <Row>
          {(selectedFRXSection2.label == "External Link" && !customCheck2) && (
            <Col lg={4} md={6} sm={6}>
              <div className="mb-3">
                <Label>URL</Label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={externalUrl2}
                  id="campaign_link_input_2"
                  onChange={(e) => {
                    setExternalUrl2(e.target.value)
                    // handleExternalUrl2(e.target.value)
                  }}
                />
                {externalUrlErrorMessage2 && (
                  <p style={{ color: "red", fontSize: 12 }}>
                    {externalUrlErrorMessage}
                  </p>
                )}
              </div>
            </Col>
          )}
        </Row>
        <Row>
          { (selectedFRXSection2?.label == "External Link" && !customCheck2) &&
            <Col lg={4} md={6} sm={6}>
              <div className="mb-3">
                <Label>Exit Message Description*</Label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={externaLinkName2}
                  id="campaign_link_input"
                  onChange={(e) => {
                  setExternalLinkName2(e.target.value)
                }}
                />
              </div>
            </Col>}
          </Row>
        {(selectedFRXSection2?.value == "ArticleDetail" && !customCheck2) && (
          <>
            <Row className="mb-3">
              <Label
                className="col-sm-8 col-form-label"
                htmlFor="formrow-firstname-input"
              >
                Blog ID
              </Label>
              <div className="col-md-10">
                <input
                  className="form-control"
                  type="text"
                  defaultValue={navigation2?.params?.data}
                  id="article_id_2"
                />
              </div>
            </Row>
            <Row className="mb-3">
              <Label
                className="col-sm-8 col-form-label"
                htmlFor="formrow-firstname-input"
              >
                Header Title
              </Label>
              <div className="col-md-10">
                <input
                  className="form-control"
                  type="text"
                  defaultValue={
                    isObject(navigation2) && navigation2?.params?.title
                  }
                  id="title_input_frx_2"
                />
              </div>
            </Row>
          </>
        )}
      </Form>
    );
  };

  const ImageDropZone = (selectedValue) => {
    return (
      <Dropzone
        onDrop={(acceptedFiles) => {
          validateFileSize(acceptedFiles, selectedValue);
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            <div className="dz-message needsclick" {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="mb-3">
                <FaCloudUploadAlt className="display-4 text-muted"/>
              </div>
              <h4>Drop files here or click to upload.</h4>
              <p
                style={{
                  fontSize: 12,
                  color: "red",
                }}
              >
                Image should be 140X140px in png
              </p>
            </div>
          </div>
        )}
      </Dropzone>
    );
  };

  const BannerImageDropZone = () => {
    return (
      <Form>
        {imageUrl && (
          <Row>
            <Col md={6}>
              <CardImg
                className="img-fluid"
                src={imageUrl}
                style={{
                  marginBottom: 15,
                  width: "400px",
                }}
                alt=""
              />
            </Col>
            <Col md={2} style={{ marginTop: "auto", marginBottom: "auto" }}>
              <div
                style={{ cursor: "pointer" }}
                className="px-3 text-danger"
                onClick={() => {
                  setImageUrl("");
                }}
              >
                <FaRegTrashAlt />Move To Trash
              </div>
            </Col>
          </Row>
        )}
        <Dropzone
          onDrop={(acceptedFiles) => {
            validateBannerFileSize(acceptedFiles);
          }}
          // disabled={pocuno}
        >
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone">
              <div className="dz-message needsclick" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="mb-3">
                  <FaCloudUploadAlt className="display-4 text-muted"/>
                </div>
                <h4>Drop files here or click to upload.</h4>
                <p style={{ fontSize: 12, color: "red" }}>
                  Image should be 585X333px in jpg
                </p>
              </div>
            </div>
          )}
        </Dropzone>
        <div className="dropzone-previews mt-3" id="file-previews">
          {selectedFiles.map((f, i) => {
            console.log("here is the selected file----->", f);
            return (
              <Card
                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                key={i + "-file"}
              >
                <div className="p-2">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      <img
                        data-dz-thumbnail=""
                        height="80"
                        className="avatar-sm rounded bg-light"
                        alt={f.name}
                        src={f.preview}
                      />
                    </Col>
                    <Col>
                      <Link to="#" className="text-muted font-weight-bold">
                        {f.name}
                      </Link>
                      <p className="mb-0">
                        <strong>{f.formattedSize}</strong>
                      </p>
                    </Col>
                  </Row>
                </div>
              </Card>
            );
          })}
        </div>
      </Form>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Edit Grab" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <Row>
                              <Col md={3} className="mb-4">
                                <h2
                                  style={{
                                    color: "#47525d57",
                                    fontWeight: "700",
                                  }}
                                >
                                  Banner
                                </h2>
                              </Col>
                            </Row>
                            <Card>
                              <CardBody>{BannerImageDropZone()}</CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card
                      style={{
                        border: "2px solid #EEEEEE",
                        borderTop: "3px solid rgba(71, 82, 93, 0.34)",
                        borderRadius: "20px",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <Col md={3} className="mb-4">
                            <h2
                              style={{ color: "#47525d57", fontWeight: "700" }}
                            >
                              Section 1
                            </h2>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => {
                                  setTitle1(e.target.value);
                                }}
                                defaultValue={title1}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setDescription1(e.target.value);
                                }}
                                defaultValue={description1}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Button Text</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setbuttonText1(e.target.value);
                                }}
                                defaultValue={buttonText1}
                              />
                            </div>
                          </Col>
                        </Row>

                        {GlobalNavDropDown()}
                        <Form>
                          {iconUrl1 && (
                            <Row>
                              <Col md={6}>
                                <CardImg
                                  className="img-fluid"
                                  src={iconUrl1}
                                  style={{
                                    marginBottom: 15,
                                    width: "50px",
                                  }}
                                  alt=""
                                />
                              </Col>
                              <Col
                                md={2}
                                style={{
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                }}
                              >
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="px-3 text-danger"
                                  onClick={() => {
                                    setIconUrl1("");
                                  }}
                                >
                                  <FaRegTrashAlt />
                                  Move To Trash
                                </div>
                              </Col>
                            </Row>
                          )}
                          {ImageDropZone(1)}
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {selectedFiles1.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                    <Card
                      style={{
                        border: "2px solid #EEEEEE",
                        borderTop: "3px solid rgba(71, 82, 93, 0.34)",
                        borderRadius: "20px",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <Col md={3} className="mb-4">
                            <h2
                              style={{ color: "#47525d57", fontWeight: "700" }}
                            >
                              Section 2
                            </h2>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => {
                                  setTitle2(e.target.value);
                                }}
                                defaultValue={title2}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setDescription2(e.target.value);
                                }}
                                defaultValue={description2}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Button Text</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setbuttonText2(e.target.value);
                                }}
                                defaultValue={buttonText2}
                              />
                            </div>
                          </Col>
                        </Row>
                  
                        {GlobalNavDropDown2()}
                        <Form>
                          {iconUrl2 && (
                            <Row>
                              <Col md={6}>
                                <CardImg
                                  className="img-fluid"
                                  src={iconUrl2}
                                  style={{
                                    marginBottom: 15,
                                    width: "50px",
                                  }}
                                  alt=""
                                />
                              </Col>
                              <Col
                                md={2}
                                style={{
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                }}
                              >
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="px-3 text-danger"
                                  onClick={() => {
                                    setIconUrl2("");
                                  }}
                                >
                                  <FaRegTrashAlt />
                                  Move To Trash
                                </div>
                              </Col>
                            </Row>
                          )}
                          {ImageDropZone(2)}
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {selectedFiles2.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={publishDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setUnPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={unPublishDate}
                                  disabled={neverEnding}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col style={{ paddingTop: 35 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={neverEnding}
                                onChange={() => {
                                  setNeverEnding(!neverEnding);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                Never-ending
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Item Version</Label>
                              <div className="col-md-12">
                                <input
                                min={0}
                                  className="form-control"
                                  onChange={(e) => {
                                    setVersion(e.target.value);
                                  }}
                                  type="number"
                                  id="version_input"
                                  defaultValue={version}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/market-place/grab-food");
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                        disabled={loader}
                        style={{
                          color: "#ffffff",
                          width: "80px",
                          marginLeft: "10px",
                        }}
                        className={"btn btn-success"}
                        onClick={() => {
                          handleSubmit();
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? (
                          <CircularProgress
                            size={15}
                            value={100}
                            color={"white"}
                          />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditGrabFoodBanner;
